import React from 'react';
import { getModalSectionTheme } from './modalTheme';

export function ModalCloseButton({ onClose, label = 'Close dialog', theme, className = '' }) {
  return (
    <button
      type="button"
      onClick={onClose}
      className={`${theme.closeBtn} ${className}`.trim()}
      aria-label={label}
    >
      <span className="text-xl leading-none" aria-hidden>
        ✕
      </span>
    </button>
  );
}

/**
 * Themed dialog shell (stripe + header). Use inside ModalOverlay or StandardModal.
 */
export default function ModalPanel({
  section = 'default',
  title,
  titleId,
  onClose,
  showCloseButton = true,
  closeLabel = 'Close dialog',
  headerHint = 'Press ESC to close',
  toolbar = null,
  children,
  sizeClass = 'max-w-md',
  maxHeightClass = 'max-h-[min(92dvh,92vh)] sm:max-h-[90vh]',
  className = '',
  panelClassName = '',
  bodyClassName = '',
  showHint = true,
}) {
  const theme = getModalSectionTheme(section);

  return (
    <div
      data-acctoo-modal-panel="true"
      className={`${theme.panel} mx-auto w-full max-w-[calc(100vw-0.5rem)] sm:max-w-none ${sizeClass} ${maxHeightClass} ${className} ${panelClassName}`}
    >
      <div className={theme.topStripe} aria-hidden />
      <div className={theme.header}>
        <div className={theme.headerRow}>
          <div className="min-w-0 flex-1">
            {title != null && title !== '' && (
              <h3 id={titleId} className={theme.headerTitle}>
                {title}
              </h3>
            )}
            {showHint && showCloseButton && <p className={theme.headerHint}>{headerHint}</p>}
          </div>
          {showCloseButton && onClose && (
            <ModalCloseButton
              onClose={onClose}
              label={closeLabel}
              theme={theme}
              className="min-h-[44px] min-w-[44px] sm:min-h-0 sm:min-w-0 touch-manipulation"
            />
          )}
        </div>
        {toolbar}
      </div>
      <div className={`${theme.body} flex-1 min-h-0 ${bodyClassName}`}>{children}</div>
    </div>
  );
}
